import { INVENTORY_TYPE } from '@/const/types/inventory';
import { SSP_BANNER_FORMAT, SSP_INTERSTITIAL_FORMAT, SSP_NATIVE_FORMAT } from '@/const/types/sspFormat';

export const SSP_FORMAT_WRAP = {
    [INVENTORY_TYPE.banner]: SSP_BANNER_FORMAT,
    [INVENTORY_TYPE.interstitial]: SSP_INTERSTITIAL_FORMAT,
    [INVENTORY_TYPE.native]: SSP_NATIVE_FORMAT,
    [INVENTORY_TYPE.rewardVideo]: {'': undefined},
}
export const SSP_FORMAT_MAP: {
    [key: number]: string
} = {
    [SSP_BANNER_FORMAT['320x50']]   :'320x50',
    [SSP_BANNER_FORMAT['320x100']]  :'320x100',
    [SSP_BANNER_FORMAT['300x250']]  :'300x250',
    [SSP_INTERSTITIAL_FORMAT['320x480']]  :'320x480',
    [SSP_INTERSTITIAL_FORMAT['480x320']]  :'480x320',
    [SSP_INTERSTITIAL_FORMAT['0x0']]  :'320x480 & 480x320',
    [SSP_NATIVE_FORMAT['1200x627 & 1200x628']]: '1200x627 & 1200x628',
    [SSP_NATIVE_FORMAT['300x300']]: '300x300',
    [SSP_NATIVE_FORMAT['400x400']]: '400x400',
    [SSP_NATIVE_FORMAT['0x0']]: '1200x627 & 1200x628 & 300x300 & 400x400 & 328x152 & 280x280 & 560x560',
}